import React, {Component} from 'react';

import Layout from '../components/layout';

class Logout extends Component{

  componentDidMount() {
    localStorage.removeItem('zenon_token');
    this.props.history.push('/');
  }
  render() {
    return (
      <Layout>
        <div className="col-lg-5 mt-5 mx-auto">
          <div className="card shadow text-center">
            <div className="card-body">
              <p className="card-title">Sorry you had to go</p>
            </div>
          </div>
        </div>
      </Layout>
    );
 }
}


export default Logout;